import { Component } from '@angular/core';
import {AlertController, IonicPage, LoadingController, NavController, NavParams, ToastController} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";
import {Storage} from '@ionic/storage';
/**
 * Generated class for the CallStatusIsNullPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

// @IonicPage()
@Component({
  selector: 'page-call-status-is-null',
  templateUrl: 'call-status-is-null.html',
})
export class CallStatusIsNullPage {

  AllData:any;

  CallStatus:any;
  CallStatusItem:any;
  FUserId:any;

  constructor(public navCtrl: NavController,
              public alertCtrl: AlertController,
              public toastCtrl: ToastController,
              public loadingCtrl: LoadingController,
              public storage: Storage,
              public service: ServiceProvider,
              public navParams: NavParams) {


    Promise.all([this.storage.get('LoginData'), this.storage.get('AllotedMobileNumber')]).then(values => {
      this.FUserId = values[0]['FUserId'];
      console.log(this.FUserId);

        this.loadvalues();
    });

    // this.AllData = this.navParams.get('Alldata');
    // console.log('AllData',this.AllData);
  }


  loadvalues(){

      let loading = this.loadingCtrl.create({
          content: 'Please wait...'
      });
      loading.present();

      this.AllData=[];
          this.service.httpcall('web_service/get_FCallStatus_isNULL_webEnquiry?Check=0').subscribe(data => {
              console.log("getNullCallData", data);

              if (data['response'] == "success") {

                  console.log("if");
                  this.AllData = data['Data'];
              } else {
                  console.log("else");
              }
                  loading.dismiss();
          });
  }


  AddCallStatus(item){

    this.CallStatus=null;
    this.CallStatusItem=null;

    this.service.httpcall('web_service/get_master_call_log_status?').subscribe(data => {

      console.log("get_master_call_log_status",data);

      if(data != ""){

        this.CallStatus=data;

        console.log(this.CallStatus);

        let myAlert = this.alertCtrl.create({
          title: 'Set Call Status',
          buttons: [
            {
              text: 'Cancel',
              role: 'cancel',
              handler: () => {
                console.log('Cancel clicked');
              }
            },
            {
              text: 'Confirm',
              handler: (data) => {
                console.log('clicked');
                console.log(data," ",item);

                let loading = this.loadingCtrl.create({
                  content: 'Please wait...'
                });
                loading.present();

                  this.service.httpcall('web_service/add_callStatus_On_webEnquiryId?FCallLogId='+item.Id+'&FCallStatusId=' + data+'&FUserId='+this.FUserId).subscribe(data => {
                      console.log(data);
                      if(data['response']=="success"){
                        loading.dismiss();
                        this.loadvalues();
                        this.presentToast(data['success_message']);
                      }else{
                        loading.dismiss();
                        this.presentToast(data['error_description']);
                      }
                    }
                    ,(error2 => {
                      this.presentToast("Timeout!");
                    }))

              }
            }
          ]
        });

        for(var i = 0; i < this.CallStatus.length; i++) {
          this.CallStatusItem=this.CallStatus[i];
          var edata=this.CallStatusItem.Name;
          console.log(edata);
          myAlert.addInput({
            type:'radio',
            label: edata,
            value: this.CallStatusItem.Id
          })
        }

        myAlert.present();
      }else{
        this.presentToast(data['error_description']);
      }
    },(error2 => {
      this.presentToast("Timeout!");
    }))
  }

  presentToast(msg){
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'bottom'
    });
    toast.present();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CallStatusIsNullPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/call-status-is-null/call-status-is-null.ts